export default __webpack_public_path__ + "9cb2a14f0441d3dd45fb3ba6631c5556.png";